export {default} from "./PaypalPage"

